import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import "./static/fonts/fonts.css";
import { mainTheme } from "./themes";
import { GlobalStyles } from "./globalStyles";
import Map from "./pages/Map";
import NotFound from "./pages/NotFound";
import LogoutForSignup from "./pages/signup/LogoutForSignup";
import { Component } from "react";
import { Provider } from "react-redux";
import store from "./store";
import history from "./utils/history";
import AdminDashboard from "pages/AdminDashboard/AdminDashboard";

const Routing = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route path={'/admin'}>
          <AdminDashboard />
        </Route>

        <Route path="/NotFound">
          <NotFound />
        </Route>

        <Route path="/signup">
          <LogoutForSignup />
        </Route>

        <Route path={`/:drawer/:projectId`}>
          <Map drawerOpen={true} />
        </Route>

        <Route path={`/:drawer`}>
          <Map drawerOpen={true} />
        </Route>

        <Route path={'/'}>
          <Map drawerOpen={false} />
        </Route>
      </Switch>
    </Router >
  );
};

class App extends Component {
  componentDidMount() { }

  render() {
    return (
      <>
        <Provider store={store}>
          <GlobalStyles />
          <ThemeProvider theme={mainTheme}>
            <div id="app">
              <Routing />
            </div>
          </ThemeProvider>
        </Provider>
      </>
    );
  }
}

export default App;
